import { render, staticRenderFns } from "./motionFocus.vue?vue&type=template&id=809605c6&scoped=true&"
import script from "./motionFocus.vue?vue&type=script&lang=js&"
export * from "./motionFocus.vue?vue&type=script&lang=js&"
import style0 from "./motionFocus.vue?vue&type=style&index=0&id=809605c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "809605c6",
  null
  
)

export default component.exports